var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 3.99992H14.6668M6.66683 7.33325V10.6666M9.3335 7.33325V10.6666M2.66683 3.99992H13.3335L12.2802 13.4799C12.2441 13.8062 12.0889 14.1076 11.8443 14.3266C11.5998 14.5455 11.2831 14.6666 10.9548 14.6666H5.0455C4.71725 14.6666 4.40054 14.5455 4.15599 14.3266C3.91145 14.1076 3.75627 13.8062 3.72016 13.4799L2.66683 3.99992ZM4.89683 2.09792C5.00466 1.86923 5.1753 1.67592 5.38883 1.54053C5.60236 1.40514 5.84999 1.33325 6.10283 1.33325H9.8975C10.1504 1.33312 10.3982 1.40495 10.6119 1.54035C10.8255 1.67575 10.9963 1.86913 11.1042 2.09792L12.0002 3.99992H4.00016L4.89683 2.09792V2.09792Z",
    stroke: "#D40B0B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashModal);
export default __webpack_public_path__ + "static/media/trashModal.66c8f145042252a56fd0e7f77b87b6b9.svg";
export { ForwardRef as ReactComponent };